import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AccountMapComponent } from "./components/account-map/account-map.component";
import { CoreModule } from "../core/core.module";
import { AccountCardComponent } from "./components/account-card/account-card.component";
import { AccountMapFilterComponent } from "./components/account-map-filter/account-map-filter.component";
import { LayoutModule } from "../layout/layout.module";
import { FormsModule } from "../forms/forms.module";
import { AccountSupportComponent } from "./components/account-support/account-support.component";
import { UserThumbnailComponent } from "./components/user-thumbnail/user-thumbnail.component";
import { UserDropdownComponent } from "./components/user-dropdown/user-dropdown.component";
import { ContactPipe } from "./pipes/contact-pipe";
import { TopOwnerComponent } from "./components/top-owner/top-owner.component";
import { UserAvatarComponent } from "./components/user-avatar/user-avatar.component";
import { AccountVerificationBannerComponent } from "./components/account-verification-banner/account-verification-banner.component";
import { OwnerCardComponent } from "./components/owner-card/owner-card.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [
    AccountMapComponent,
    AccountCardComponent,
    AccountMapFilterComponent,
    AccountSupportComponent,
    UserThumbnailComponent,
    UserDropdownComponent,
    ContactPipe,
    TopOwnerComponent,
    UserAvatarComponent,
    AccountVerificationBannerComponent,
    OwnerCardComponent,
  ],
  imports: [CommonModule, FormsModule, CoreModule, LayoutModule, RouterModule],
  exports: [
    AccountMapComponent,
    AccountCardComponent,
    AccountSupportComponent,
    UserThumbnailComponent,
    UserDropdownComponent,
    ContactPipe,
    TopOwnerComponent,
    UserAvatarComponent,
    AccountVerificationBannerComponent,
    OwnerCardComponent,
  ],
})
export class AccountModule {}
